import { SubscriptionActions } from '@store/reducers/subscription'
import { put, select } from 'redux-saga/effects'

import { authSelector } from '@/hooks/useAuth'
import { OpenConfirmation } from '@/store'
import type { AuthState } from '@/types'
import { UpgradePlanActions } from '../actions'

export function* upgrade({
  payload: { planId },
}: ReturnType<typeof UpgradePlanActions.upgrade>) {
  const { authenticated, paymentProvider }: AuthState =
    yield select(authSelector)

  if (!authenticated) {
    yield put(UpgradePlanActions.redirect({ planId }))

    return
  }

  if (paymentProvider === 'braintree') {
    yield put(
      OpenConfirmation({
        message: 'To switch plan, please update payment details.',
        label: 'Update',
        title: 'Update payment information',
        then: [SubscriptionActions.requestBillingPortal()],
      })
    )

    return
  }

  yield put(UpgradePlanActions.updatePayment({ planId, planType: 'monthly' }))
}
